<div class="py-3 position-relative">
  <label
    for="query"
    class="visually-hidden">Search Ping Identity</label>
  <input
    id="query"
    type="text"
    tabindex="1"
    autocomplete="off"
    class="form-control form-control-lg bg-white rounded-1 border-gray-800 fs-6"
    (focus)="focus.emit(input)"
    [class.rounded-bottom-0]="!!typeahead?.isPopupOpen()"
    placeholder="Search..."
    name="query"
    [(ngModel)]="input"
    [ngbTypeahead]="autocompleteSearch"
    popupClass="d-flex flex-column w-100 shadow rounded-0 rounded-bottom-1 pt-0"
    [resultTemplate]="rt"
    [focusFirst]="false"
    (selectItem)="handleSelectItem($event)"
    (search)="$event.stopPropagation()"
    (keyup.enter)="setParams(input)">
  @if (!input) {
    <span
      class="material-symbols-outlined position-absolute text-gray-800">search</span>
  }
  @if (input) {
    <button
      (click)="setParams('')"
      class="btn-close position-absolute"><span class="visually-hidden">Close</span></button>
  }
</div>
<ng-template
  #rt
  let-r="result">
  @if (r?.query) {
    <div
      class="px-3 mx-n3 mt-n1 border-top">
      <div class="ellipsis my-2">
        <span class="material-symbols-outlined text-gray-600 me-2">search</span>Search for
        <strong>{{ r.query }}</strong>
      </div>
    </div>
  }
  @if (!r?.query) {
    <div
      class="px-3 py-2 mx-n3 mt-n1 border-top">
      @if (r?.title) {
        <div
          [innerHTML]="r.title"
          class="mb-1 ellipsis"></div>
        <div class="d-flex small text-gray-600">
          <div>{{ r.source | source }}</div>
          <div class="vr mx-2"></div>
          <div class="ellipsis">{{ r.url }}</div>
        </div>
      }
      @if (!r) {
        <div>
          <h5 class="card-title placeholder-glow mb-1">
            <span class="placeholder w-50"></span>
          </h5>
          <p class="card-text placeholder-glow small">
            <span class="placeholder w-100"></span>
          </p>
        </div>
      }
    </div>
  }
</ng-template>
